import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const analyticsPluginKey: PluginKey = new PluginKey('analyticsPlugin');
